import { OnInit } from "@angular/core";
var LayoutComponent = /** @class */ (function () {
    function LayoutComponent() {
    }
    LayoutComponent.prototype.ngOnInit = function () {
        window.preLoaderStart();
    };
    return LayoutComponent;
}());
export { LayoutComponent };
